import { combineReducers } from "redux";

// reducers
import user from "./user";

export default combineReducers({
  user,
});
